import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, defineMessages } from 'react-intl'

import {
  Wrapper,
  InfoSection,
  Info,
  Link
} from './Downloads.styles'
import { GradientWrapper } from '../../../../DashboardSettings.styles'

const messages = defineMessages({
  downloads: {
    id: 'dashboard.referrals.downloads',
    defaultMessage: 'Downloads to help you spread the word'
  },
  presentation: {
    id: 'dashboard.referrals.presentation',
    defaultMessage: 'Presentation slides'
  },
  headteacherLetter: {
    id: 'dashboard.referrals.headteacherLetter',
    defaultMessage: 'Email this letter to your school leader'
  },
  classReport: {
    id: 'dashboard.referrals.classReport',
    defaultMessage: 'Your class report'
  },
  shareVideo: {
    id: 'dashboard.referrals.shareVideo',
    defaultMessage: 'Share this 80-second video'
  }
})

const Downloads = (props) => {
  return (
    <GradientWrapper direction={props.direction} noBg={props.noBg}>
      <Wrapper>
        <Info halfWidth={props.halfWidth}>
          <FormattedMessage {...messages.downloads} />
        </Info>
        <Link
          href='https://www.dropbox.com/s/ega69xivui4a11c/Night%20Zookeeper%20Teacher%20Presentation%20Slides.pdf?dl=0'
          target='_blank'
        >
          <FormattedMessage {...messages.presentation} />
        </Link>
        <Link
          href='https://docs.google.com/document/d/1CXU9xYkCLwZZxkocOB3ds9Mshz9EhCrQs-OnWsJWxNo/edit'
          target='_blank'
        >
          <FormattedMessage {...messages.headteacherLetter} />
        </Link>
        {/* commented out as reports aren't ready
          <Link
          href=""
          target="_blank"
        >
          <FormattedMessage {...messages.classReport} />
        </Link> */}
        <Link
          href='https://vimeo.com/201653717'
          target='_blank'
        >
          <FormattedMessage {...messages.shareVideo} />
        </Link>
      </Wrapper>
    </GradientWrapper>
  )
}

export default Downloads
